import React from 'react';

interface GaugeChartProps {
    value?: number;
}

const GaugeChart: React.FC<GaugeChartProps> = ({ value = 0 }) => {
    const clampedValue = Math.max(0, Math.min(100, value || 0));
    
    const viewBoxWidth = 320;
    const viewBoxHeight = 200;
    const centerX = viewBoxWidth / 2;
    const centerY = viewBoxHeight * 0.70;
    const outerRadius = 120;
    const innerRadius = 85;
    
    const angleDeg = 180 - (clampedValue / 100) * 180;
    const angleRad = (angleDeg * Math.PI) / 180;
    
    const needleLength = outerRadius - 5;
    const needleEndX = centerX + needleLength * Math.cos(angleRad);
    const needleEndY = centerY - needleLength * Math.sin(angleRad);
    
    const createArcPath = (startPercent: number, endPercent: number) => {
        const startAngle = 180 - (startPercent / 100) * 180;
        const endAngle = 180 - (endPercent / 100) * 180;
        
        const startRad = (startAngle * Math.PI) / 180;
        const endRad = (endAngle * Math.PI) / 180;
        
        const outerStartX = centerX + outerRadius * Math.cos(startRad);
        const outerStartY = centerY - outerRadius * Math.sin(startRad);
        const outerEndX = centerX + outerRadius * Math.cos(endRad);
        const outerEndY = centerY - outerRadius * Math.sin(endRad);
        
     
        const innerStartX = centerX + innerRadius * Math.cos(startRad);
        const innerStartY = centerY - innerRadius * Math.sin(startRad);
        const innerEndX = centerX + innerRadius * Math.cos(endRad);
        const innerEndY = centerY - innerRadius * Math.sin(endRad);
        

        return `M ${outerStartX} ${outerStartY} 
                L ${outerEndX} ${outerEndY}
                L ${innerEndX} ${innerEndY}
                L ${innerStartX} ${innerStartY}
                Z`;
    };
    
    
    const segments = [
        { start: 0, end: 20, color: '#E97389' },
        { start: 20, end: 40, color: '#FF7539' },
        { start: 40, end: 60, color: '#F5A623' },
        { start: 60, end: 80, color: '#64ADF0' },
        { start: 80, end: 100, color: '#23CF95' },
    ];
    
    const scaleLabels = [0, 20, 40, 60, 80, 100];
    const labelRadius = outerRadius + 15;
    
    return (
        <div style={{ position: 'relative', width: '14rem', height: '80%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <svg viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} style={{ width: '100%', height: '100%', overflow: 'visible' }}>
                {segments.map((segment, index) => (
                    <path
                        key={index}
                        d={createArcPath(segment.start, segment.end)}
                        fill={segment.color}
                        stroke="none"
                    />
                ))}
                
                {scaleLabels.map((label, index) => {
                    const labelAngle = 180 - (label / 100) * 180;
                    const labelRad = (labelAngle * Math.PI) / 180;
                    const labelX = centerX + labelRadius * Math.cos(labelRad);
                    const labelY = centerY - labelRadius * Math.sin(labelRad);
                    
                    return (
                        <text
                            key={index}
                            x={labelX}
                            y={labelY}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fontSize="18"
                            fill="#666"
                            fontFamily="sans-serif"
                            fontWeight="400"
                        >
                            {label}
                        </text>
                    );
                })}
                
                <line
                    x1={centerX}
                    y1={centerY}
                    x2={needleEndX}
                    y2={needleEndY}
                    stroke="rgb(45, 57, 103)"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                />
                
                <circle
                    cx={centerX}
                    cy={centerY}
                    r="6"
                    fill="rgb(45, 57, 103)"
                />
                
                <text
                    x={centerX}
                    y={centerY + 40}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize="42"
                    fill="#2D3967"
           
                    fontWeight="bold"
                >
                    {Math.round(clampedValue)}%
                </text>
            </svg>
        </div>
    );
};

export default GaugeChart;

